import gql from 'graphql-tag';

import { BrandFragments } from './fragments/BrandType';
import { PageFragments } from './fragments/PageType';

export const filterBrands = gql`
  query FilterBrands($first: Int, $searchTerm: String) {
    brands(first: $first, filters: { nameContains: $searchTerm }) {
      edges {
        node {
          ...BrandId
          name
        }
      }
    }
  }
  ${BrandFragments.id}
`;

export const getDiscoveredBrands = gql`
  query GetDiscoveredBrands($filters: PageFilters) {
    entry: pages(filters: $filters, first: 10) {
      edges {
        node {
          ...PageId
          displayName
          followedByCurrentUser
          followers {
            totalCount
          }
          logo(croppingStrategy: CENTER, height: 256) {
            url
          }
          coverImages(first: 1, croppingStrategy: CENTER, width: 400, height: 400) {
            edges {
              node {
                width
                height
                url
              }
            }
          }
        }
      }
    }
  }
  ${PageFragments.id}
`;

export const getBrandIsFollowed = gql`
  query GetBrandIsFollowed($externalId: String!) {
    entry: page(externalId: $externalId) {
      followedByCurrentUser
    }
  }
`;
